import { render, staticRenderFns } from "./bo-editable-button-popup.vue?vue&type=template&id=a908f5d8"
import script from "./bo-editable-button-popup.vue?vue&type=script&lang=js"
export * from "./bo-editable-button-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports